

export const questionnaire = {
  "questionnaire_title": "Questionnaires",
  "questionnaire_point": "points",
  "questionnaire_questionnaire": "Questions",
  "questionnaire_minutes": "minutes",
  "questionnaire_continue": "Continue",
  "questionnaire_start": "Start"
}